// extracted by mini-css-extract-plugin
export default {"container":"SectionContainer_container__b0EiG","title":"SectionContainer_title__-IV59","content":"SectionContainer_content__HTUoz"};